import $ from 'static/script/libs/jquery'
export default $.ajax;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/ajax.js